const moment = require('moment');
const handlePrintTimeAmPm = require('../utils/print-am-pm-of-time');
const handlePrintStartEndTimeOfMetting = (startAt, endAt) => {
    const subtractedStartAt = moment(startAt).subtract('3', 'hours').subtract('25', 'minutes');
    const subtractedEndAt = moment(endAt).subtract('3', 'hours').subtract('25', 'minutes');

    return moment(subtractedStartAt).format('YYYY/MM/DD') === moment(subtractedEndAt).format('YYYY/MM/DD')
        ? `${moment(subtractedStartAt).format('YYYY/MM/DD')}، ساعت
    ${moment(subtractedStartAt).format('hh:mm')} ${handlePrintTimeAmPm(subtractedStartAt)}
    الی
    ${moment(subtractedEndAt).format('hh:mm')} ${handlePrintTimeAmPm(subtractedEndAt)}`
        : `${moment(subtractedStartAt).format('YYYY/MM/DD')}، ساعت
        ${moment(subtractedStartAt).format('hh:mm')} ${handlePrintTimeAmPm(subtractedStartAt)}
        الی
        ${moment(subtractedEndAt).format('YYYY/MM/DD')}، ساعت
        ${moment(subtractedEndAt).format('hh:mm')} ${handlePrintTimeAmPm(subtractedEndAt)}`;
};

module.exports = handlePrintStartEndTimeOfMetting;
